import React, { useState } from "react"

function CFilter({
  allItemsLabel,
  items, // all available filter options
  onChange, // callback that is called with the string array of selected uuids
}) {
  const [activeFilters, setActiveFilters] = useState([])
  const handleFilterChange = event => {
    setActiveFilters(currentFilters => {
      const uuid = Number(event.target.value)
      const active = event.target.checked
      const newActiveFilters = active
        ? [...currentFilters, uuid]
        : currentFilters.filter(f => f !== uuid)
      onChange(newActiveFilters)
      return newActiveFilters
    })
  }

  const resetFilters = () => {
    setActiveFilters([])
    onChange([])
  }

  return (
    <div className="c-Filter" role="group" data-testid="filter">
      {allItemsLabel && (
        <div className="c-Filter-item" data-testid="all-news-filter">
          <label className="c-Filter-label">
            <input
              className="c-Filter-radio"
              type="radio"
              name="filter-all"
              value="all"
              checked={activeFilters.length === 0}
              onChange={resetFilters}
            />
            <span className="c-Filter-box">{allItemsLabel}</span>
          </label>
        </div>
      )}
      {items.map(item => (
        <div className="c-Filter-item" key={item.uid} data-testid={`filter-item-${item.uid}`}>
          <label className="c-Filter-label">
            <input
              className="c-Filter-radio"
              type="checkbox"
              name={`filter-${item.uid}`}
              value={item.uid}
              checked={activeFilters.includes(item.uid)}
              disabled={item.disabled ? true : undefined}
              onChange={handleFilterChange}
            />
            <span className="c-Filter-box">{item.title}</span>
          </label>
        </div>
      ))}
    </div>
  )
}

export default CFilter
